/** Shared inline styles for the UsernameLink modal flow. */
export const linkStyles = {
  overlay: {
    position: "fixed",
    inset: 0,
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    backdropFilter: "blur(4px)",
    padding: "20px",
  },
  card: {
    position: "relative",
    backgroundColor: "var(--color-bg-surface)",
    border: "1px solid var(--color-border)",
    borderRadius: "12px",
    padding: "40px 36px 32px",
    maxWidth: "420px",
    width: "100%",
    textAlign: "center",
    boxShadow: "0 16px 48px rgba(0, 0, 0, 0.4)",
  },
  closeButton: {
    position: "absolute",
    top: "12px",
    right: "12px",
    background: "none",
    border: "none",
    color: "var(--color-text-tertiary)",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "color 150ms ease",
  },
  iconWrap: { marginBottom: "20px" },
  title: {
    color: "var(--color-text-primary)",
    fontSize: "20px",
    fontWeight: "600",
    margin: "0 0 8px 0",
    letterSpacing: "-0.01em",
  },
  subtitle: {
    color: "var(--color-text-secondary)",
    fontSize: "14px",
    lineHeight: "1.5",
    margin: "0 0 24px 0",
  },
  platformToggle: {
    display: "flex",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid var(--color-border-hover)",
    marginBottom: "16px",
  },
  platformButton: {
    flex: 1,
    padding: "8px 16px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    color: "var(--color-text-tertiary)",
    backgroundColor: "transparent",
    border: "none",
    transition: "all 150ms ease",
  },
  platformButtonActive: {
    color: "var(--color-text-primary)",
    backgroundColor: "var(--color-accent-muted)",
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: "14px",
    fontWeight: "500",
    backgroundColor: "var(--color-bg-elevated)",
    border: "1px solid var(--color-border)",
    borderRadius: "8px",
    color: "var(--color-text-primary)",
    outline: "none",
    marginBottom: "12px",
    boxSizing: "border-box",
    transition: "border-color 150ms ease",
  },
  error: {
    color: "var(--color-error)",
    fontSize: "13px",
    marginBottom: "12px",
    textAlign: "left",
  },
  submitButton: {
    width: "100%",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    backgroundColor: "var(--color-accent)",
    color: "var(--color-text-on-accent)",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 150ms ease",
    marginBottom: "16px",
  },
  successMessage: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    color: "var(--color-success)",
    fontSize: "15px",
    fontWeight: "600",
    padding: "20px 0",
  },
  footer: {
    color: "var(--color-text-secondary)",
    fontSize: "12px",
    margin: 0,
  },
  coachLevelSection: {
    marginTop: "4px",
    textAlign: "center",
  },
  coachLevelRecommendation: {
    fontSize: "13px",
    lineHeight: "1.5",
    color: "var(--color-text-secondary)",
    margin: "0 0 12px 0",
  },
  coachLevelToggle: {
    display: "flex",
    borderRadius: "8px",
    overflow: "hidden",
    border: "1px solid var(--color-border-hover)",
    marginBottom: "10px",
  },
  coachLevelToggleBtn: {
    flex: 1,
    padding: "8px 16px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    color: "var(--color-text-tertiary)",
    backgroundColor: "transparent",
    border: "none",
    transition: "all 150ms ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  coachLevelToggleBtnActive: {
    color: "var(--color-text-primary)",
    backgroundColor: "var(--color-accent-muted)",
  },
  coachLevelDescription: {
    fontSize: "12px",
    lineHeight: "1.5",
    color: "var(--color-text-secondary)",
    margin: "0 0 16px 0",
    minHeight: "36px",
  },
  saveButton: {
    width: "100%",
    padding: "10px 20px",
    fontSize: "14px",
    fontWeight: "600",
    backgroundColor: "var(--color-accent)",
    color: "var(--color-text-on-accent)",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 150ms ease",
  },
} as const;
